import React, { Component } from "react";
import Measure from "react-measure";
import Radar from "./Radar";

class Section extends Component {
  state = {
    dimensions: {
      width: -1,
      height: -1
    }
  };

  render() {
    var { width, height } = this.state.dimensions;

    return (
      <Measure
        bounds
        onResize={contentRect =>
          this.setState({ dimensions: contentRect.bounds })
        }
      >
        {({ measureRef }) => {
          width = width > 320 ? width / 3 : 320;
          height = width;
          return (
            <section ref={measureRef}>
              <div className="heading">
                <h3>{this.props.title}</h3>
                <hr />
              </div>
              <div className="description">{this.props.children}</div>
              {this.props.radarData !== undefined &&
              this.props.radarData.length !== undefined ? (
                <div className="data">
                 { this.props.radarName ?
                  <h4>{ this.props.radarName }</h4>
                  :
                  null
                 }
                  <ul>
                    {this.props.radarData.map(item => {
                      return (
                        <li key={item.color+item.skill} style={{color: item.color, borderColor: item.color}}>
                          { item.skill }
                          <span style={{color: item.color}}>{item.level}</span>
                        </li>
                      )
                    })}
                  </ul>
                  <Radar
                    radarData={this.props.radarData}
                    levels={3}
                    width={width}
                    height={height}
                  />
                </div>
              ) : null}
            </section>
          );
        }}
      </Measure>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section.js